module.exports = "/_next/static/resources/art-d0db1b9bf212de85cdbc619410e7f69d.jpg";